import { useSelector } from "react-redux"
import Collapse from "../../../../../../shared/components/ui/collapse/Collapse"
import SectionList from "../../../../../../shared/components/pages/myLearningPage/myLearningDomainPage/SectionList/SectionList"
import MyCourseItem from "../../../../../../shared/components/features/courseItem/myCourseItem/MyCourseItem";
import MyCourseItemWithOptions from "../../../../../../shared/components/features/courseItem/myCourseItem/myCourseItemWithOptions/MyCourseItemWithOptions";
import classes from './AssignStudyGroupSections.module.css'

const AssignStudyGroupSections = ({ title, list, collapse = false, expanded, options = false }) => {

    const { texts } = useSelector(state => state.translate)

    const generatList = () => {
        return (
            <SectionList
                titel={!collapse ? `${title} (${list?.length})` : ""}
                classNameList={classes.List}
                list={list}
                ItemComponent={options ? MyCourseItemWithOptions : MyCourseItem}
                itemPropName="course"
                textForEmptyList={texts.noEnvironments}
                classNameForEmptyList={classes.EmptyState}
            />)
    }

    return (
        <div className={classes.SectionList}>
            {collapse ?
                <Collapse title={`${title} (${list?.length})`} expanded={expanded ? expanded : list?.length > 0} listboxId={"studyGroupsInactive"}  >
                    {generatList()}
                </Collapse>
                :
                generatList()}
        </div >
    )
}
export default AssignStudyGroupSections